import React from 'react';

const OrderTextProgress = ({ orderTextAmount, textList, t }) => {
  const deliveredCount = textList.filter((x) => x.delivered).length;
  const validatedCount = textList.filter((x) => x.validated).length;
  return (
    <div className="box-flex-cols">
      <div>
        {t('Textes livrés')} : {deliveredCount}/{orderTextAmount}
      </div>
      <div>
        {t('Textes validés')} : {validatedCount}/{orderTextAmount}
      </div>
    </div>
  );
};

export default OrderTextProgress;
